<template>
  <div class="directions">
    <HeroBanner
        :background-image="bannerImage"
        title="오시는 길"
        sub-title="전문성을 바탕으로 한 최고의 보청기전문기업, <br>다비치 히어링 보청기입니다."
    />

    <div class="directions-content">
      <!-- 다비치 히어링 보청기 본사 -->
      <div class="location-section">
        <h2 class="location-title">다비치 히어링 보청기 본사</h2>
        <div class="map-container">
          <div ref="map1" class="map"></div>
        </div>
        <div class="location-info">
          <div class="info-row">
            <span class="info-label">주소</span>
            <span class="info-value">서울특별시 종로구 수표로 91 다비치타워 8-11F</span>
          </div>
          <div class="info-row">
            <span class="info-label">전화번호</span>
            <span class="info-value">1668-1407</span>
          </div>
        </div>
      </div>

      <!-- 고객가치경영연구원 -->
      <div class="location-section">
        <h2 class="location-title">고객가치경영연구원</h2>
        <div class="map-container">
          <div ref="map2" class="map"></div>
        </div>
        <div class="location-info">
          <div class="info-row">
            <span class="info-label">주소</span>
            <span class="info-value">대전광역시 동구 중동 92-1(중앙로 198)</span>
          </div>
          <div class="info-row">
            <span class="info-label">전화번호</span>
            <span class="info-value">070-7428-6637~8</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeroBanner from "@/components/HeroBanner.vue";
import bannerBg from '@/assets/images/heros/01-top-img.png';

export default {
  name: 'Directions',
  components: {
    HeroBanner,
  },
  data() {
    return {
      bannerImage: [bannerBg],
      locations: [
        {
          name: '다비치 히어링 보청기 본사',
          address: '서울특별시 종로구 수표로 91 다비치타워 8-11F',
          lat: 37.5688,
          lng: 126.9889
        },
        {
          name: '고객가치경영연구원',
          address: '대전광역시 동구 중동 92-1(중앙로 198)',
          lat: 36.3275,
          lng: 127.4305
        }
      ]
    };
  },
  mounted() {
    this.initMaps();
  },
  methods: {
    initMaps() {
      if (typeof naver === 'undefined') {
        console.error('Naver Maps API not loaded');
        return;
      }

      // 첫 번째 지도 (본사)
      const map1 = new naver.maps.Map(this.$refs.map1, {
        center: new naver.maps.LatLng(this.locations[0].lat, this.locations[0].lng),
        zoom: 16,
        scrollWheel: false,
        draggable: false,
        disableDoubleClickZoom : true
      });

      new naver.maps.Marker({
        position: new naver.maps.LatLng(this.locations[0].lat, this.locations[0].lng),
        map: map1,
        icon: {
          content: `<div class="marker">
                      <div class="marker-txt active">${this.locations[0].name}</div>
                      <img src="https://img.davich.com/image/sub/support/map/icon-main-marker.png"
                           alt="본사 마커"
                           style="margin: 0px; padding: 0px; border: 0px solid transparent; display: block;
                                  max-width: none; max-height: none; -webkit-user-select: none; position: absolute;
                                  width: 45px; height: 45px; left: 0px; top: 20px;">
                    </div>`,
          size: new naver.maps.Size(45, 45)
        }
      });

      // 두 번째 지도 (연구원)
      const map2 = new naver.maps.Map(this.$refs.map2, {
        center: new naver.maps.LatLng(this.locations[1].lat, this.locations[1].lng),
        zoom: 16,
        scrollWheel: false,
        draggable: false,
        disableDoubleClickZoom : true
      });

      new naver.maps.Marker({
        position: new naver.maps.LatLng(this.locations[1].lat, this.locations[1].lng),
        map: map2,
        icon: {
          content: `<div class="marker">
                      <div class="marker-txt active">${this.locations[1].name}</div>
                      <img src="https://img.davich.com/image/sub/support/map/icon-main-marker.png"
                           alt="연구원 마커"
                           style="margin: 0px; padding: 0px; border: 0px solid transparent; display: block;
                                  max-width: none; max-height: none; -webkit-user-select: none; position: absolute;
                                  width: 45px; height: 45px; left: 0px; top: 20px;">
                    </div>`,
          size: new naver.maps.Size(45, 45)
        }
      });
    }
  }
};
</script>

<style>
/* 마커 애니메이션 (전역 스타일) */
@keyframes floatUpDown {
  0%, 100% {
    transform: translateX(-35%) translateY(0);
  }
  50% {
    transform: translateX(-35%) translateY(-3px);
  }
}

/* 마커 스타일 (네이버 지도에서 동적으로 삽입되는 요소에 적용) */
.directions .map-container .marker .marker-txt {
  position: absolute;
  margin-top: 14px;
  box-sizing: content-box;
  text-align: center;
  top: -38px;
  white-space: nowrap;
  min-width: 100px;
  left: 50%;
  transform: translateX(-35%);
  padding: 15px 20px;
  background-color: #fff;
  color: #000;
  border-radius: 30px;
  margin-bottom: 10px;
  max-width: none;
  max-height: none;
  box-shadow: 0 2px 5px 0 rgba(34, 34, 34, .1);
  font-weight: 500;
  font-size: 14px;
}

.directions .map-container .marker .marker-txt.active {
  background-color: #0056AA;
  color: #fff;
}

</style>

<style scoped lang="scss">
.directions {
  .directions-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 500px;
    margin: 0 auto;
    padding: 72px 36px 80px;
    background: #FFFFFF;
    gap: 60px;

    .location-section {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 24px;

      .location-title {
        font-family: 'Noto Sans KR', sans-serif;
        font-weight: 700;
        font-size: 24px;
        line-height: 32px;
        letter-spacing: -0.6px;
        color: #222222;
        margin: 0;
        padding-bottom: 12px;
        text-align: center;
        //border-bottom: 2px solid #222222;
      }

      .location-info {
        display: flex;
        flex-direction: column;
        border-bottom: 1px solid #DDDDDD;
        border-top: 1px solid #222222;
        //border-radius: 4px;
        overflow: hidden;

        .info-row {
          display: flex;
          align-items: center;
          min-height: 52px;
          &:not(:last-child) {
            border-bottom: 1px solid #DDDDDD;
          }

          .info-label {
            width: 104px;
            min-width: 104px;
            //padding: 12px 16px;
            //background: #F5F5F5;
            font-family: 'Noto Sans KR', sans-serif;
            font-weight: 500;
            font-size: 16px;
            padding: 16px;
            line-height: 24px;
            color: #222222;
            height: 100%;
          }

          .info-value {
            flex: 1;
            padding: 16px;
            font-family: 'Noto Sans KR', sans-serif;
            font-weight: 400;
            font-size: 18px;
            line-height: 24px;
            color: #222222;
            background: #FFFFFF;
          }
        }
      }

      .map-container {
        width: 100%;
        height: 320px;
        //border-radius: 4px;
        overflow: hidden;
        //border: 1px solid #DDDDDD;

        .map {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  @media (max-width: 768px) {
    .directions-content {
      padding: 40px 20px 60px;
      gap: 48px;

      .location-section {
        gap: 20px;

        .location-title {
          font-size: 20px;
          line-height: 28px;
          padding-bottom: 10px;
        }

        .location-info {
          .info-row {
            min-height: 48px;

            .info-label {
              width: 100px;
              min-width: 100px;
              padding: 10px 12px;
              font-size: 15px;
              line-height: 22px;
            }

            .info-value {
              padding: 10px 12px;
              font-size: 15px;
              line-height: 22px;
            }
          }
        }

        .map-container {
          height: 280px;
        }
      }
    }
  }

  @media (max-width: 450px) {
    .directions-content {
      padding: 30px 12px 50px;
      gap: 40px;

      .location-section {
        gap: 16px;

        .location-title {
          font-size: 18px;
          line-height: 26px;
          padding-bottom: 8px;
        }

        .location-info {
          .info-row {
            flex-direction: column;
            align-items: stretch;
            min-height: auto;

            .info-label {
              width: 100%;
              padding: 10px 12px;
              font-size: 14px;
              line-height: 20px;
              border-right: none;
              border-bottom: 1px solid #DDDDDD;
            }

            .info-value {
              padding: 10px 12px;
              font-size: 14px;
              line-height: 20px;
            }
          }
        }

        .map-container {
          height: 240px;
        }
      }
    }
  }
}
</style>